import { useSelect } from '@refinedev/antd';
import { IExperienceAction } from '../../interfaces/experience';
import { Select } from 'antd';
import { BaseOption, HttpError } from '@refinedev/core';

export const ExperienceActionSelect = (props: any) => {
  const { selectProps } = useSelect<IExperienceAction>({
    resource: 'experienceActions',
    optionLabel: 'name',
    optionValue: 'id',
    meta: {
      fields: ['id', 'name', 'title', 'description'],
    },
    onSearch: (value) => [
      {
        field: 'name',
        operator: 'contains',
        value,
      },
    ],
  });

  return <Select showSearch id={props.id} placeholder="行動を選択" {...selectProps} {...props} />;
};
